import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

const UserInvitedModal = ({ open, setOpen , email, loader }) => {
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">User Invited</div>


        <div className="lg:text-[14px] text-[13px] text-center">
        An invitation email was sent to {loader ? <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} /> : email}
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(96,91,255,0.1)',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    setOpen(false)
                  }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default UserInvitedModal;
